
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.849 13.951L9.113 1.06a1.247 1.247 0 00-2.227 0L.151 13.95c-.33.634-.1 1.425.514 1.766.184.102.39.156.598.156h13.472c.699 0 1.265-.583 1.265-1.303 0-.216-.052-.428-.151-.619zM8 13.877a.803.803 0 01-.79-.815c0-.45.354-.814.79-.814.437 0 .79.364.79.814 0 .45-.353.815-.79.815zm.859-8.194l-.227 4.97c0 .36-.283.652-.633.652a.642.642 0 01-.632-.652L7.14 5.685a.875.875 0 01.85-.924h.008a.873.873 0 01.859.924l.002-.002z","fill":"#DC143C"}})])
          )
        }
      }
    